import { EReadyAccommodate } from 'shared/types/form';
import { EStatus } from 'shared/types/listing';

export function getAreaLabel(objectType: 'room' | 'house' | 'flat' | 'bed' | null) {
  if (objectType === 'room' || objectType === 'bed') {
    return 'Площадь комнаты';
  } else if (objectType === 'house') {
    return 'Площадь дома';
  }

  return 'Площадь квартиры';
}

export function formatPhone(phone: string) {
  return phone.replace(/^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 $1 $2-$3-$4');
}

export function formatLocation(location: '_Moscow_' | '_MoscowRegion_' | '_Other_' | string) {
  if (location === '_Moscow_') {
    return 'Москва';
  }

  if (location === '_MoscowRegion_') {
    return 'Московская область';
  }

  if (location === '_Other_') {
    return 'Другой';
  }

  return location;
}

export function formatPriceType(priceType: 'free' | 'symbolic' | 'utility_bill') {
  switch (priceType) {
    case 'free':
      return 'Бесплатно';
    case 'utility_bill':
      return 'За оплату квитанций';
    case 'symbolic':
      return 'За символическую плату';
    default:
      return '—';
  }
}

export function formatDate(dateString: string) {
  if (!dateString) {
    return '—';
  }
  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return '—';
    }

    return date.toLocaleDateString('ru-RU');
  } catch (_) {
    return '—';
  }
}

export function formatStatus(status: EStatus) {
  switch (status) {
    case EStatus.New:
      return 'Новая';
    case EStatus.Phone_not_available:
      return 'Не дозвонились';
    case EStatus.Canceled:
      return 'Не актуальна';
    case EStatus.Confirming:
      return 'Уточняется заселение';
    case EStatus.Busy:
      return 'Занято';
    case EStatus.Available:
      return 'Свободно';
    default:
      return '—';
  }
}

export function formatObjectType(type: 'flat' | 'house' | 'room' | 'bed') {
  switch (type) {
    case 'flat':
      return 'Квартира';
    case 'house':
      return 'Дом';
    case 'room':
      return 'Комната';
    case 'bed':
      return 'Спальное место';
    default:
      return '—';
  }
}

export function formatStringArray(arr: string[]): string {
  return arr.length ? arr.join(', ') : '—';
}

export function formatRoomsCount(
  roomsCount: 'one' | 'two' | 'three' | 'four' | 'five' | 'six_and_more' | 'studio' | undefined,
): string {
  switch (roomsCount) {
    case 'one':
      return '1';
    case 'two':
      return '2';
    case 'three':
      return '3';
    case 'four':
      return '4';
    case 'five':
      return '5';
    case 'six_and_more':
      return '6+';
    case 'studio':
      return 'Студия';
    default:
      return '—';
  }
}

export function formatArea(area: number | undefined): string {
  return area != null ? `${area} м²` : '—';
}

export function formatString(text: string): string {
  return text.trim() || '—';
}

export function formatNumber(n: number | undefined): string {
  return n == null ? '—' : n.toString();
}

const readyAccommodateMap: {
  [key in EReadyAccommodate]: string;
} = {
  [EReadyAccommodate.During_treatment]: 'На время лечения',
  [EReadyAccommodate.Fire]: 'Пожар',
  [EReadyAccommodate.Refugees]: 'Беженцы',
  [EReadyAccommodate.River_flooding]: 'Разлив рек',
};

export function formatReadyAccommodate(value: EReadyAccommodate) {
  return readyAccommodateMap[value];
}
